<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'App',

}
</script>

<style>
/* Nhãn kết nối EMC */
.yhy-append-wrap {
  position: fixed;
  bottom: 40px;
  z-index: 9999;
}
</style>
